import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { setCurrentCampaign, setDeleteCampaignId } from "../../../slices/campaigns/reducer";
import { toggleDeleteCampaignModal, toggleDeleteTableItemModal, toggleEditCampaignModal, toggleEditTableItemModal } from "../../../slices/modals/reducer";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedItem } from "../../../slices/folder/reducer";
import { permissionTypes } from "../../../common/tablePermissionTypes"; 
import { push } from "redux-first-history";
import { useParams } from "react-router-dom";
import { createSelector } from "reselect";

function TableActionButtons({ rowData, viewItem, dispatch, permissions = [], company, type, showAnalytics = false }) { 
  const [editDropdown, setEditDropdown] = useState(false);

  const toggleEditDropdown = () => {
    setEditDropdown(!editDropdown);
  };

  const togglePreviewDropdown = () => {
    setPreviewDropdown(!previewDropdown);
  };

  function editItem() {
    dispatch(setSelectedItem(rowData));
    dispatch(toggleEditTableItemModal());
  }

  function showDeleteModal() {
    dispatch(setSelectedItem(rowData));
    dispatch(toggleDeleteTableItemModal());
  }

  function seeAnalytics() {
    const foundClient = company.clients.find(item => item._id === rowData.clientId);
    const foundBrand = foundClient.brands.find(item => item._id === rowData.brandId);
    const foundMarket = foundBrand.markets.find(item => item._id === rowData.marketId);
    const foundClientName = foundClient.clientName.toLowerCase().replaceAll(/\s+/g, "-");
    const foundBrandName = foundBrand.name.toLowerCase().replaceAll(/\s+/g, "-");
    const foundMarketName = foundMarket.name.toLowerCase().replaceAll(/\s+/g, "-");
    dispatch(push(`/${foundClientName}/${foundBrandName}/${foundMarketName}/analytics/${rowData._id}`));
  }
  
  return (
    <div className="d-flex align-items-center gap-1 table-button">
      <Dropdown isOpen={editDropdown} toggle={toggleEditDropdown}>
        <DropdownToggle tag="button" type="button" className="btn-icon btn btn-info btn-sm table-button">
          <i className="ri-more-line align-middle table-button"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={viewItem}>
            <i className="ri-eye-line align-bottom me-1"></i> View
          </DropdownItem>
          {permissions.includes(permissionTypes[type][1]) ?
            <DropdownItem onClick={editItem}>
              <i className="ri-pencil-line align-bottom me-1"></i> Edit
            </DropdownItem>
            : null}
          {permissions.includes(permissionTypes[type][2]) ?
            <DropdownItem className="py-2 border-top" onClick={showDeleteModal}>
              <i className="ri-delete-bin-line align-bottom me-1"></i> Delete
            </DropdownItem>
            : null}
        </DropdownMenu>
      </Dropdown>
      {showAnalytics ? permissions.includes(permissionTypes[type][3]) ? !rowData.hasOwnProperty('isFolder') ?
        <button className="btn-icon btn btn-success btn-sm table-button" onClick={seeAnalytics}>
          <i className="mdi mdi-pulse align-middle fs-14 table-button"></i>
        </button>
        : null : null : null}
    </div>
  )
}

export default TableActionButtons
